<template>
  <div>
    <PaymentListFilter />

    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="payments"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:[`item.name`]="{ item }">
          <span class="text-center">
            {{ item.host.name }}
          </span>
        </template>
        <template v-slot:[`item.username`]="{ item }">
          <span class="text-center">
            {{ item.host.username }}
          </span>
        </template>
        <template v-slot:[`item.city`]="{ item }">
          <span class="text-center">
            {{ item.city.name }}
          </span>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <span class="text-center">
            {{ formatMoney(item.total) }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="goToHostInvoices(item.host.id)">
                <v-icon color="grey lighten-1"> mdi-text-box-outline </v-icon>
                <span class="d-block body-2 ml-3">
                  {{ $t('payment.list.actions.hostInvoices') }}
                </span>
              </v-list-item>
              <v-list-item @click="pay(item)">
                <v-icon color="grey lighten-1"> mdi-cash-fast </v-icon>
                <span class="d-block body-2 ml-3">
                  {{ $t('payment.list.actions.createTransfer') }}
                </span>
              </v-list-item>
              <v-list-item @click="goToAppointments(item.host.id)">
                <v-icon color="grey lighten-1"> mdi-calendar-month </v-icon>
                <span class="d-block body-2 ml-3">
                  {{ $t('payment.list.actions.appointmentsDoneByHost') }}
                </span>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <ModalPayHost ref="modalPayHost" />
    <h-pagination :fetch="fetchPayments" :requireOrderByFilter="false" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { catalogMonetary } from '@/util/catalog'
import { paymentHeader } from './listHeaders/paymentListHeaders'

import PaymentListFilter from '@/components/payment/PaymentListFilter'
import ModalPayHost from '@/components/payment/ModalPayHost'

import router from '@/router'

export default {
  name: 'PaymentList',
  components: {
    PaymentListFilter,
    ModalPayHost,
  },
  data() {
    return {
      headers: paymentHeader,
      formatMoney: catalogMonetary,
    }
  },
  computed: {
    ...mapGetters(['isLoading', 'payments', 'itemsPerPage']),
  },

  methods: {
    ...mapActions(['fetchPayments']),

    pay(payment) {
      this.$refs.modalPayHost.openModal(payment.host.id)
    },

    goToHostInvoices(hostId) {
      router.push({ name: 'hostInvoices', params: { id: hostId } })
    },

    goToAppointments(hostId) {
      router.push({
        name: 'adminHostAppointmentsList',
        params: { hostId: hostId },
      })
    },
  },

  mounted() {
    this.fetchPayments()
  },
}
</script>
